import React from 'react'

import { StyledText } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'

import type { OriginalEmployeeConsent } from '../resources/reports/consents'

type StatusBadgeProps = {
  status: OriginalEmployeeConsent['employeeConsentStatus']['name']
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusConfig = {
    Draft: {
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      dotColor: 'bg-yellow-500',
    },
    Published: {
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      dotColor: 'bg-green-500',
    },
    Closed: {
      bgColor: 'bg-red-100',
      textColor: 'text-red-800',
      dotColor: 'bg-red-500',
    },
  }

  const { textColor, dotColor } = statusConfig[status]

  return (
    <div className={`inline-flex items-center rounded-full px-3 py-1 ${textColor}`}>
      <div className={`mr-2 h-2 w-2 rounded-full ${dotColor}`} />
      <StyledText size="small" colorMode="gray" className="flex">
        <Translation
          id="{status}"
          status={
            <StyledText capitalize className="text-sm font-medium">
              {status}
            </StyledText>
          }
        />
      </StyledText>
    </div>
  )
}
